export const SIMILAR_ARTICLES_TITLE = "Related Articles";
export const BUZZ_CAROUSEL_CLASS_NAME = "buzz-carousel";
export const BUZZ_FULL_WIDTH_IMAGE_CLASS_NAME =
  "buzz-full-width-image";
export const BUZZ_CAROUSEL_OFFSET = "18px";
export const BUZZ_CAROUSEL_IMAGE_LIST_CLASS_NAME =
  "images-list";
export const BUZZ_CAROUSEL_SCROLL_INTERVAL = 500;
export const BUZZ_SHARE_MARKET_SHARE_TITLE =
  "Buzz | Share.Market";

export const ARTICLE_BANNER_IMG_FALLBACK =
  "https://static.share.market/images/blog/5120/1448/fallback_header_web.png";

export const ARTICLE_BANNER_IMG_FALLBACK_MOBILE =
  "https://static.share.market/images/blog/1440/752/fallback_header_mobile.png";

export const ARTICLE_BANNER_IMG_FALLBACK_ALT =
  "Buzz Article";

export const ARTICLE_DATA = {
  ARTICLE_TITLE: "t0",
  ARTICLE_SLUG: "t1",
  ARTICLE_CATEGORY: "t2",
};

export const ARTICLE_CATEGORY_PILL_FLOW =
  "ARTICLE_CATEGORY_PILL";

export const ARTICLE_SHARE_WIDGET_FLOW =
  "ARTICLE_SHARE_WIDGET";

export const ARTICLE_RELATED_TAGS_FLOW =
  "ARTICLE_RELATED_TAGS";

export const RELATED_ARTICLES_FLOW = "RRELATED_ARTICLES";

export const POPULAR_CATEGORIES_FLOW = "POPULAR_CATEGORIES";
